// 实时获取消息列表变化
import Cookies from "js-cookie";
let ws = null;
let setInter = null;

// 尝试从 Cookie 中获取 userInfo 字符串
const userInfoString = Cookies.get("userInfo");

// 尝试解析 userInfo 字符串为对象，如果解析失败则返回空对象
let initialUserInfo = {};
try {
  initialUserInfo = userInfoString ? JSON.parse(userInfoString) : {};
} catch (error) {
  console.error("Error parsing userInfo from Cookie:", error);
}

export function NewWebSocket(sendInfo) {
  const userInfo = initialUserInfo;
  const userId = initialUserInfo.userId;
  const getSchoolId = Cookies.get("schoolId") || null;

  function onOpen() {
    // 半分钟发送一次心跳
    setInter = setInterval(() => {
      ws.send(
        JSON.stringify({
          code: "0",
        })
      );
    }, 15000);
    console.log("连接成功");
  }
  function onMessage(event) {
    const ret = JSON.parse(event.data);
    // console.log("websocket 请求", ret);
    if (ret.type === 1) {
      sendInfo(event);
    }
  }
  function onClose(event) {
    console.log("连接关闭");
  }
  function onError(event) {
    console.log("任务连接发生异常，可刷新页面重试");
  }

  function WsDestroying() {
    clearInterval(setInter);
    setInter = null;
    ws.close();
    ws = null;
  }

  ws = new WebSocket(
    window.g.IM_SOCKET + `?userId=${userId}&tenantId=${getSchoolId}`
  );
  ws.onopen = onOpen;
  ws.onclose = onClose;
  ws.onmessage = onMessage;
  ws.onerror = onError;
  return { ws, WsDestroying };
}
